<div class="container-fluid">
  <div class="row fixed-header align-items-center py-2">
    <div class="col-12 col-md-8 mb-2 mb-md-0 d-flex justify-content-between">
      <app-pagetitle *ngIf="showPageTitle && deviceList.length > 0" title="{{ deviceName }}"
        [breadcrumbItems]="breadCrumbItems" [deviceInfo]="true" [deviceDatas]="deviceList"
        (deviceSelected)="handleDeviceSelection($event)">
      </app-pagetitle>
      <div class="d-flex d-md-none justify-content-between">
        <i (click)="refreshData()" title="refresh" class="ri-refresh-line text-dark display-6 p-2 rounded" style="
            font-size: 20px;
            color: white !important;
            background-color: #007d79;
            height: 40px;
          ">
        </i>

        <i (click)="backbtn('backToDashboard')" title="back to dashboard"
          class="ri-logout-box-line text-dark display-6 p-2 rounded" style="
            font-size: 20px;
            color: white !important;
            background-color: #007d79;
            height: 40px;
            margin-left: 2px;
          ">
        </i>
      </div>
    </div>
    <div
      class="col-12 col-md-4 d-none d-md-flex justify-content-between justify-content-md-end align-items-center gap-2">
      <button *ngIf="isSignal" (click)="analogopenModal(signaltemplate)" type="button"
        class="btn btn-success d-flex align-items-center gap-2 px-3 py-2 shadow-sm rounded-pill">
        <i class=" ri-rss-fill fs-5"></i>
        <span class="fw-semibold"> Signal {{ signal }} %</span>
      </button>
      <button (click)="refreshData()" type="button" class="btn btn-success ms-2 ml-1 small">
        <i class="ri-refresh-line text-dark align-middle display-6"></i> Refresh
      </button>
      <button (click)="backbtn('backToDashboard')" type="button" class="btn btn-primary ms-2 ml-1 small">
        <strong>&lt;&lt;</strong> Back
      </button>
    </div>
  </div>
</div>

<div class="container-fluid mobile-margin-top">
  <div class="row">
    <div class="col-md-8">
      <div class="card" style="height: 200px">
        <div class="card-body">
          <div class="d-flex justify-content-between">
            <div>LUT : {{ epochToHHMMSS(LUT ? LUT : 0) }}</div>
            <div *ngIf="isAnalog">
              <button class="btn btn-primary btn-sm" (click)="analogopenModal(analogtemplate)">
                Analog
              </button>
            </div>
            <div *ngIf="
                params['configType'] != 'no_part' &&
                partcountType == 'digital' &&
                iscycleData
              ">
              <ui-switch [(ngModel)]="isChecked" (change)="onSwitchChange($event)" defaultBoColor="#dfdfdf" size="small"
                color="#f46a6a">
              </ui-switch>
            </div>
          </div>
          <div *ngIf="params['configType'] != 'no_part'">
            <div *ngIf="!isChecked && isData">
              <span class="fw-bold" style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                " [ngStyle]="{ color: intervalFlag ? 'green' : 'red' }">Hourly Part-Count</span>

              <!-- <app-partcountchart [gaugeArray]="hourlyData" class="chart-container"></app-partcountchart> -->
               <div
                echarts
                class="echarts mt-1"
                [options]="option"
                (chartClick)="onChartClick($event, templateallpdf)"
                style="height: 200px; width: 100%"
              ></div>
            </div>
            <div *ngIf="isChecked">
              <div echarts [options]="cyclegap" class="chart-container" style="width: 100%; height: 200px"></div>
            </div>

            <div *ngIf="showload2" class="d-flex flex-column align-items-center justify-content-center text-center">
              <ngx-spinner bdColor="rgba(0, 0, 0, 0)" size="medium" color="rgba(0, 0, 0, 0.1)"
                type="ball-scale-multiple" [fullScreen]="false"></ngx-spinner>
              <span style="margin-top: 50px">Loading</span>
            </div>
            <div *ngIf="!isChecked && !showload2" align="center">
              <p class="mt-2 text-muted">
                No data available / Fetching data...
              </p>
            </div>
          </div>
          <div *ngIf="params['configType'] == 'no_part'" align="center" style="margin-top: 50px">
            <p>Not Available</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card" style="height: 200px">
        <div class="card-header d-flex align-items-center py-2">
          <div class="spinner-grow m-1" role="status" [style.color]="statusColor(status)"
            style="width: 1rem; height: 1rem"></div>
          <div class="flex-grow-1 text-center" style="color: #007d79; font-weight: bold">
            {{ currentShift.shiftName }}
            <span class="d-none d-xl-inline">[ {{ currentShift.startTime }} -
              {{ currentShift.endTime }} ]</span>
          </div>
          <div class="text-right d-flex align-items-center gap-2">
            <h6 class="mb-0" [style.color]="statusColor(status)">
              {{ currentStatus }}
            </h6>

            <span *ngIf="interlockData && interlockData.length > 0"
              class="position-relative d-inline-flex align-items-center justify-content-center"
              title="Interlock Release"
              (click)="openInterlockModal()"
              style="cursor:pointer;">
              <span class="d-inline-flex align-items-center justify-content-center text-red position-relative"
                style="width:26px; height:26px; z-index:1; animation: interlockPulse 0.8s ease infinite; color:'red'">
                <i class="mdi mdi-alert" style="font-size:0.85rem;"></i>
              </span>
            </span>
          </div>
        </div>

        <div class="card-body">
          <div #marque class="marquee" *ngIf="isInsite && !showload">
            <div class="marquee-content">
              <ul class="marquee-list">
                <li class="marquee-item">
                  {{ currentItem }}
                </li>
              </ul>
            </div>
          </div>
          <div *ngIf="showload" class="d-flex flex-column align-items-center justify-content-center text-center">
            <ngx-spinner bdColor="rgba(0, 0, 0, 0)" size="medium" color="rgba(0, 0, 0, 0.1)" type="ball-scale-multiple"
              [fullScreen]="false"></ngx-spinner>
            <span style="margin-top: 70px">Loading</span>
          </div>
          <div class="marquee" style="display: flex; justify-content: center; align-items: center" *ngIf="!isInsite">
            Fetching Data
          </div>
        </div>
        <div class="card-footer py-2">
          <div class="d-flex flex-column gap-1" style="font-size: 12px;">

            <div class="d-flex align-items-center gap-1" style="min-width: 0;">
              <strong style="white-space: nowrap;">Operator:</strong>
              <span class="highlight-primary text-truncate"
                    style="min-width: 0; flex: 1; font-weight: bold;"
                    [title]="operatorName || 'Not Mapped'">
                {{ operatorName ? operatorName : "Not Mapped" }}
              </span>
            </div>

            <div class="d-flex align-items-center gap-1" style="min-width: 0;">
              <strong style="white-space: nowrap;">Part:</strong>
              <ng-container *ngIf="params['configType'] != 'no_part'">
                <span class="highlight-success text-truncate"
                      style="min-width: 0; flex: 1; font-weight: bold;"
                      [title]="partName || 'Not Planned'">
                  {{ partName ? partName : "Not Planned" }}
                </span>
              </ng-container>
              <ng-container *ngIf="params['configType'] == 'no_part'">
                <span class="highlight-success" style="font-weight: bold;">NA</span>
              </ng-container>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid mt-0">
  <div class="row">
    <div class="col-12">
      <div class="card" style="height: fit-content">
        <div class="card-body">
          <div class="row">
            <div class="col-md-8" style="cursor: pointer" (click)="openModal(piechart, 'currentDay')">
              <app-detailedgantt *ngIf="showChart" [gaugeArray]="currentDay" [title]="today2" [shiftData]="allShift"
                [timeZone]="timeZone">
              </app-detailedgantt>
              <div style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 100px;
                  width: 100%;
                " *ngIf="!showChart">
                Fetching Data
              </div>
            </div>
            <div class="col-md-4" style="height: fit-content">
              <div class="card-body rounded" style="padding: 8px; border: 1px solid #e0ded8">
                <div class="d-flex justify-content-between">
                  <h6 style="
                      text-align: center;
                      margin-bottom: 6px;
                      font-size: 12px;
                    ">
                    <b *ngIf="!liveBool">Total Energy :
                      {{
                      (overAllData[0] && overAllData[0].total_Energy) || 0
                      }}
                      KwH</b>
                    <b *ngIf="liveBool">Total Energy : {{ t_energy || 0 }} KwH</b>
                  </h6>
                  <h6 (click)="
                      openModal2(downtimeTemplate, 'downtimedata', 'currentDay')
                    " style="
                      text-align: center;
                      margin-bottom: 6px;
                      font-size: 12px;
                      cursor: pointer;
                    " title="Click to view hourly Downtime">
                    <i class="ri-bar-chart-fill downtime-icon"></i>
                    <b>Downtime : {{ downtimeDurationsHHMMSS[0] }}</b>
                  </h6>
                </div>

                <div class="d-flex justify-content-between">
                  <div class="text-center">
                    <p class="text fw-bold" style="margin: 4px 0; padding: 2px; line-height: 1">
                      <b *ngIf="params['configType'] != 'no_part'">Planned Part :
                        {{
                        (overAllData[0] &&
                        overAllData[0].total_PlannedPart) ||
                        0
                        }}</b>
                      <b *ngIf="params['configType'] == 'no_part'">Planned Part : NA</b>
                    </p>
                  </div>
                  <div class="text-center">
                    <p *ngIf="params['configType'] != 'no_part'" class="text fw-bold" style="
                        margin: 4px 0;
                        padding: 2px;
                        line-height: 1;
                        cursor: pointer;
                      " title="click to view hourly partcount" (click)="
                        openModal2(currenttemplate, 'partData', 'currentDay')
                      ">
                      <i class="ri-bar-chart-fill downtime-icon"></i>
                      <b *ngIf="!liveBool && !isPartTwo">Part Count :
                        {{
                        (overAllData[0] && overAllData[0]["pin1_count"]) || 0
                        }}</b>
                      <!-- <b *ngIf="!liveBool && isPartTwo">P1 : {{ overAllData[0] && overAllData[0]['partcount'] || 0}} - P2 : {{ overAllData[0] && overAllData[0]['partcount'] || 0}} </b> -->
                      <b *ngIf="!liveBool && isPartTwo">
                        <span title="Partcount 1">
                          P1 :
                          {{
                          (overAllData &&
                          overAllData[0] &&
                          overAllData[0].pin1_count) ||
                          0
                          }}
                        </span>
                        -
                        <span title="Partcount 2">
                          P2 :
                          {{
                          (overAllData &&
                          overAllData[0] &&
                          overAllData[0].pin2_count) ||
                          0
                          }}
                        </span>
                      </b>
                      <b *ngIf="liveBool && !isPartTwo">Part Count : {{ Ai_partcount || 0 }}</b>
                      <b *ngIf="liveBool && isPartTwo">
                        <span title="Partcount 1">
                          P1 : {{ Ai_partcount || 0 }}
                        </span>
                        -
                        <span title="Partcount 2">
                          P2 : {{ Ai_partcount2 || 0 }}
                        </span></b>
                    </p>
                    <p class="text fw-bold" style="
                        margin: 4px 0;
                        padding: 2px;
                        line-height: 1;
                        cursor: pointer;
                      " *ngIf="params['configType'] == 'no_part'">
                      <b>Part Count : NA</b>
                    </p>
                  </div>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="text-center">
                    <p class="fw-semibold mb-1">Energy Cost</p>
                    <h6 *ngIf="!liveBool" class="mb-0">
                      ₹
                      {{
                      (overAllData[0] && overAllData[0]["energy_cost"]) || 0
                      }}
                    </h6>
                    <h6 *ngIf="liveBool" class="mb-0">
                      ₹ {{ (allData && allData["energy_cost"]) || 0 }}
                    </h6>
                  </div>
                  <div class="text-center">
                    <p class="fw-semibold mb-1">Production Cost</p>
                    <h6 *ngIf="!liveBool" class="mb-0">
                      ₹
                      {{
                      (overAllData[0] && overAllData[0]["production_cost"]) ||
                      0
                      }}
                    </h6>
                    <h6 *ngIf="liveBool" class="mb-0">
                      ₹ {{ (allData && allData["production_cost"]) || 0 }}
                    </h6>
                  </div>
                  <div class="text-center">
                    <p class="fw-semibold mb-1">Total Cost</p>
                    <h6 *ngIf="!liveBool" class="mb-0">
                      ₹
                      {{
                      (overAllData[0] && overAllData[0]["total_cost"]) || 0
                      }}
                    </h6>
                    <h6 *ngIf="liveBool" class="mb-0">
                      ₹ {{ (allData && allData["total_cost"]) || 0 }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid mt-0">
  <div class="row">
    <div class="col-12">
      <div class="card" style="height: fit-content">
        <div class="card-body">
          <div class="row">
            <div class="col-md-8" style="cursor: pointer" (click)="openModal(piechart, 'yesterDay')">
              <app-detailedgantt *ngIf="showChart1" [gaugeArray]="yesterDay" [title]="proviousDay"
                [shiftData]="allShift" [timeZone]="timeZone"></app-detailedgantt>
              <div style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 100px;
                  width: 100%;
                " *ngIf="!showChart1">
                Fetching Data
              </div>
            </div>
            <div class="col-md-4" style="height: fit-content">
              <div class="card-body rounded" style="padding: 8px; border: 1px solid #e0ded8">
                <div class="d-flex justify-content-between">
                  <h6 style="
                      text-align: center;
                      margin-bottom: 6px;
                      font-size: 12px;
                    ">
                    <b>Total Energy :
                      {{
                      (overAllData[1] && overAllData[1].total_Energy) || 0
                      }}
                      KwH</b>
                  </h6>
                  <h6 (click)="
                      openModal2(downtimeTemplate, 'downtimedata', 'yesterDay')
                    " style="
                      text-align: center;
                      margin-bottom: 6px;
                      font-size: 12px;
                      cursor: pointer;
                    " title="Click to view hourly Downtime">
                    <i class="ri-bar-chart-fill downtime-icon"></i>
                    <b>Downtime : {{ downtimeDurationsHHMMSS[1] }}</b>
                  </h6>
                </div>
                <div class="d-flex justify-content-between">
                  <div class="text-center">
                    <p class="text fw-bold" style="margin: 4px 0; padding: 2px; line-height: 1">
                      <b *ngIf="params['configType'] != 'no_part'">Planned Part :
                        {{
                        (overAllData[1] &&
                        overAllData[1].total_PlannedPart) ||
                        0
                        }}</b>
                      <b *ngIf="params['configType'] == 'no_part'">Planned Part : NA</b>
                    </p>
                  </div>
                  <div class="text-center">
                    <p *ngIf="params['configType'] != 'no_part'" class="text fw-bold" style="
                        margin: 4px 0;
                        padding: 2px;
                        line-height: 1;
                        cursor: pointer;
                      " title="click to view hourly partcount" (click)="
                        openModal2(currenttemplate, 'partData', 'yesterDay')
                      ">
                      <i class="ri-bar-chart-fill downtime-icon"></i>
                      <b *ngIf="!isPartTwo">Part Count :
                        {{
                        (overAllData[1] && overAllData[1]["pin1_count"]) || 0
                        }}</b>
                      <b *ngIf="isPartTwo">
                        <span title="Partcount 1">
                          P1 :
                          {{
                          (overAllData &&
                          overAllData[1] &&
                          overAllData[1].pin1_count) ||
                          0
                          }}
                        </span>
                        -
                        <span title="Partcount 2">
                          P2 :
                          {{
                          (overAllData &&
                          overAllData[1] &&
                          overAllData[1].pin2_count) ||
                          0
                          }}
                        </span>
                      </b>
                    </p>
                    <p class="text fw-bold" style="
                        margin: 4px 0;
                        padding: 2px;
                        line-height: 1;
                        cursor: pointer;
                      " *ngIf="params['configType'] == 'no_part'">
                      <b>Part Count : NA</b>
                    </p>
                  </div>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="text-center">
                    <p class="fw-semibold mb-1">Energy Cost</p>
                    <h6 class="mb-0">
                      ₹
                      {{
                      (overAllData[1] && overAllData[1]["energy_cost"]) || 0
                      }}
                    </h6>
                  </div>
                  <div class="text-center">
                    <p class="fw-semibold mb-1">Production Cost</p>
                    <h6 class="mb-0">
                      ₹
                      {{
                      (overAllData[1] && overAllData[1]["production_cost"]) ||
                      0
                      }}
                    </h6>
                  </div>
                  <div class="text-center">
                    <p class="fw-semibold mb-1">Total Cost</p>
                    <h6 class="mb-0">
                      ₹
                      {{
                      (overAllData[1] && overAllData[1]["total_cost"]) || 0
                      }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid mt-0">
  <div class="row">
    <div class="col-12">
      <div class="card" style="height: fit-content">
        <div class="card-body">
          <div class="row">
            <div class="col-md-8" style="cursor: pointer" (click)="openModal(piechart, 'previousyesterDay')">
              <app-detailedgantt *ngIf="showChart1" [gaugeArray]="previousyesterDay" [title]="proviousDay2"
                [shiftData]="allShift" [timeZone]="timeZone"></app-detailedgantt>
              <div style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 100px;
                  width: 100%;
                " *ngIf="!showChart1">
                Fetching Data
              </div>
            </div>
            <div class="col-md-4" style="height: fit-content">
              <div class="card-body rounded" style="padding: 8px; border: 1px solid #e0ded8">
                <div class="d-flex justify-content-between">
                  <h6 style="
                      text-align: center;
                      margin-bottom: 6px;
                      font-size: 12px;
                    ">
                    <b>Total Energy :
                      {{
                      (overAllData[2] && overAllData[2].total_Energy) || 0
                      }}
                      KwH</b>
                  </h6>
                  <h6 (click)="
                      openModal2(
                        downtimeTemplate,
                        'downtimedata',
                        'previousyesterDay'
                      )
                    " style="
                      text-align: center;
                      margin-bottom: 6px;
                      font-size: 12px;
                      cursor: pointer;
                    " title="Click to view hourly Downtime">
                    <i class="ri-bar-chart-fill downtime-icon"></i>
                    <b>Downtime : {{ downtimeDurationsHHMMSS[2] }}</b>
                  </h6>
                </div>

                <div class="d-flex justify-content-between">
                  <div class="text-center">
                    <p class="text fw-bold" style="margin: 4px 0; padding: 2px; line-height: 1">
                      <b *ngIf="params['configType'] != 'no_part'">Planned Part :
                        {{
                        (overAllData[2] &&
                        overAllData[2].total_PlannedPart) ||
                        0
                        }}</b>
                      <b *ngIf="params['configType'] == 'no_part'">Planned Part : NA</b>
                    </p>
                  </div>
                  <div class="text-center">
                    <p *ngIf="params['configType'] != 'no_part'" class="text fw-bold" style="
                        margin: 4px 0;
                        padding: 2px;
                        line-height: 1;
                        cursor: pointer;
                      " title="click to view hourly partcount" (click)="
                        openModal2(
                          currenttemplate,
                          'partData',
                          'previousyesterDay'
                        )
                      ">
                      <i class="ri-bar-chart-fill downtime-icon"></i>
                      <b *ngIf="!isPartTwo">Part Count :
                        {{
                        (overAllData[2] && overAllData[2]["pin1_count"]) || 0
                        }}</b>
                      <b *ngIf="isPartTwo">
                        <span title="Partcount 1">
                          P1 :
                          {{
                          (overAllData &&
                          overAllData[2] &&
                          overAllData[2].pin1_count) ||
                          0
                          }}
                        </span>
                        -
                        <span title="Partcount 2">
                          P2 :
                          {{
                          (overAllData &&
                          overAllData[2] &&
                          overAllData[2].pin2_count) ||
                          0
                          }}
                        </span>
                      </b>
                    </p>
                    <p class="text fw-bold" style="
                        margin: 4px 0;
                        padding: 2px;
                        line-height: 1;
                        cursor: pointer;
                      " *ngIf="params['configType'] == 'no_part'">
                      <b>Part Count : NA</b>
                    </p>
                  </div>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="text-center">
                    <p class="fw-semibold mb-1">Energy Cost</p>
                    <h6 class="mb-0">
                      ₹
                      {{
                      (overAllData[2] && overAllData[2]["energy_cost"]) || 0
                      }}
                    </h6>
                  </div>
                  <div class="text-center">
                    <p class="fw-semibold mb-1">Production Cost</p>
                    <h6 class="mb-0">
                      ₹
                      {{
                      (overAllData[2] && overAllData[2]["production_cost"]) ||
                      0
                      }}
                    </h6>
                  </div>
                  <div class="text-center">
                    <p class="fw-semibold mb-1">Total Cost</p>
                    <h6 class="mb-0">
                      ₹
                      {{
                      (overAllData[2] && overAllData[2]["total_cost"]) || 0
                      }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #piechart let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Status Chart</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div echarts [options]="chartOptions" class="chart"></div>
  </div>
</ng-template>
<ng-template #currenttemplate let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">{{ getTitle(trendData) }} Trend</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <div class="partData" *ngIf="trendData === 'partData'">
      <div class="col-md-12 text-center" *ngIf="showHourchart">
        <span class="fw-bold" [ngStyle]="{ color: intervalFlag ? 'green' : 'red' }">Hourly Part-Count</span>
        <app-partcountchart *ngIf="showHourchart" [gaugeArray]="hourlyData2"></app-partcountchart>
      </div>
      <div *ngIf="!showHourchart" align="center">
        <p class="mt-2 text-muted">No data available / Fetching data...</p>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #downtimeTemplate let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Hourly Downtime Trend</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <div>
      <div class="col-md-12 text-center">
        <span class="fw-bold">Hourly Downtime</span>
        <div echarts [options]="hourlyDowntimeOption" class="chart"></div>
      </div>
      <!-- <div align="center">
        <p class="mt-2 text-muted">No data available / Fetching data...</p>
      </div> -->
    </div>
  </div>
</ng-template>
<ng-template #analogtemplate let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Analog Trend</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <div class="col-md-12 text-center" *ngIf="analogChart">
      <div echarts [options]="analogChart" class="chart-container" style="width: 100%; height: 250px"></div>
    </div>

    <div *ngIf="!analogChart" class="text-center">
      <p class="mt-2 text-muted">No analog configured</p>
    </div>
  </div>
</ng-template>
<ng-template #signaltemplate let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Signal Strength</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <div class="col-md-12 text-center" *ngIf="signalChart">
      <div echarts [options]="signalChart" class="chart-container" style="width: 100%; height: 250px"></div>
    </div>

    <div *ngIf="!signalChart" class="text-center">
      <p class="mt-2 text-muted">No Signal Data</p>
    </div>
  </div>
</ng-template>
<ng-template #interlock let-modal="close">
  <!-- Modal Header -->
  <div class="modal-header py-2 px-3">
    <h6 class="modal-title fw-bold mb-0">⚡ Interlock Monitor</h6>
     <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <!-- Modal Body -->
  <div class="modal-body bg-light p-3">
    <div class="row g-2 align-items-stretch">
      <div class="col-md-4 d-flex" *ngFor="let item of interlockData; let i = index">

        <div class="card shadow-sm w-100" [ngClass]="item.interlockReason === 1 ? 'border-success' : 'border-warning'"
          style="border-width:2px !important; border-radius:10px;">

          <!-- Card Header -->
          <div class="card-header d-flex justify-content-between align-items-center px-2 py-1"
            [ngClass]="item.interlockReason === 1 ? 'bg-success bg-opacity-10 border-bottom border-success' : 'bg-warning bg-opacity-10 border-bottom border-warning'"
            style="border-radius:8px 8px 0 0;">
            <span class="badge fw-bolder" style="font-size:0.85rem; letter-spacing:0.5px;"
              [ngClass]="item.interlockReason === 1 ? 'bg-success text-white' : 'bg-warning text-dark'">
              {{ item.parameter }}
            </span>
          </div>

          <!-- Card Body -->
          <div class="card-body px-2 py-2 flex-grow-1">

            <!-- Timestamp -->
            <div class="bg-white rounded px-2 py-1 mb-2 border" style="font-size:0.75rem;">
              <span class="fw-bolder text-dark">🕒 {{ item.start_ts | date:'medium' }}</span>
            </div>

            <!-- Reason -->
            <div class="mb-1">
              <label class="text-uppercase fw-bold mb-1 d-block" style="font-size:0.62rem; letter-spacing:0.8px;"
                [ngClass]="item.interlockReason === 1 ? 'text-success' : 'text-warning'">
                Reason
              </label>
              <select class="form-select form-select-sm py-1" style="font-size:0.72rem;"
                [ngClass]="item.interlockReason === 1 ? 'border-success' : 'border-warning'"
                [(ngModel)]="item.reasonCode" (ngModelChange)="getChangeReason($event, item)">
                <option value="" disabled>— Select Reason —</option>
                <option *ngFor="let reason of reasonData" [value]="reason['reasonCode']">
                  {{ reason["reason"] }}
                </option>
              </select>
            </div>

            <!-- Sub Reason -->
            <div class="mb-1" *ngIf="item.subreasonData && item.subreasonData.length > 0">
              <label class="text-uppercase fw-bold mb-1 d-block" style="font-size:0.62rem; letter-spacing:0.8px;"
                [ngClass]="item.interlockReason === 1 ? 'text-success' : 'text-warning'">
                Sub Reason
              </label>
              <select class="form-select form-select-sm py-1" style="font-size:0.72rem;"
                [ngClass]="item.interlockReason === 1 ? 'border-success' : 'border-warning'"
                [(ngModel)]="item.subReasonCode">
                <option value="" disabled>— Select Sub Reason —</option>
                <option *ngFor="let reason of item.subreasonData" [value]="reason['subReasonCode']">
                  {{ reason["subReason"] }}
                </option>
              </select>
            </div>

          </div>

          <!-- Card Footer -->

          <div class="card-footer bg-white d-flex justify-content-end align-items-center px-2 py-1"
            [ngClass]="item.interlockReason === 1 ? 'border-top border-success' : 'border-top border-warning'"
            style="border-radius:0 0 8px 8px;">
            <button class="btn btn-sm px-3 fw-semibold" style="font-size:0.72rem;"
              [ngClass]="item.interlockReason === 1 ? 'btn-success' : 'btn-warning'" [disabled]="item.isPending"
              (click)="submitInterlock(item)">
              <span *ngIf="item.isPending" class="spinner-border spinner-border-sm me-1" role="status"></span>
              {{ item.isPending ? 'Waiting...' : 'Submit' }}
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #templateallpdf role="document" let-modal="close">
  <div class="modal-header">
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div
      *ngIf="partBreakdownOption"
      echarts
      [options]="partBreakdownOption"
      class="chart-container"
    ></div>
  </div>
</ng-template>